/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "theme-ui";

import { useSpring, animated as a, config as springConfig } from "react-spring";

import store from "../../appStore";
import { useSnapshot } from "valtio";

import Logo from "./HeaderBar/Logo";
import { useEffect } from "react";

const LoadingScreen = (props) => {
  const snap = useSnapshot(store);

  const spring = useSpring({
    opacity: snap.loadingFinished ? (snap.datastoreReady ? 0 : 1) : 1,
    config: snap.loadingFinished ? (snap.datastoreReady ? springConfig.molasses : springConfig.stiff) : springConfig.stiff,
    delay: snap.loadingFinished ? 500 : 0,
  });

  // useEffect(() => {
  //   console.log("LoadingScreen", snap.loadingFinished);
  // }, [snap.loadingFinished]);

  return (
    <a.div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "black",
        zIndex: 9999999999999,
        pointerEvents: "none",
        opacity: spring.opacity,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div className="loader" />
      <div
        style={{
          position: "fixed",
        }}
      >
        <Logo logoWhite pointerEvents="none" />
        <h3 style={{ color: "white", textAlign: "center", fontSize: "1vw" }}>Loading...</h3>
      </div>
    </a.div>
  );
};

export default LoadingScreen;
